function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.348 26a36.39 36.39 0 0 1-10.08 5.617 1.5 1.5 0 0 1-1.954-1.826c.705-2.437 1.217-4.582 1.537-6.43A10.977 10.977 0 0 1 0 15v-4C0 4.925 4.925 0 11 0h10c6.075 0 11 4.925 11 11v4c0 6.075-4.925 11-11 11h-6.652zm-.973-1.78l.274-.22H21a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9H11a9 9 0 0 0-9 9v4a8.982 8.982 0 0 0 3.54 7.155l.473.362-.092.588c-.286 1.82-.757 3.914-1.414 6.282a34.472 34.472 0 0 0 8.868-5.168zM8 10h8v2H8v-2zm0 4h16v2H8v-2z"
});

var SvgChatInbox = function SvgChatInbox(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "8bf73ed7a1a5fcbe3ddc861727b9d1fa.svg";
export { SvgChatInbox as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/chat-inbox.svg
// module id = null
// module chunks = 